import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 48 48" fill="none" {...props}>
      <title>{props.title || 'Computer'}</title>
      <g xmlns="http://www.w3.org/2000/svg">
        <path
          d="M24 0C37.2857 0 48 10.7143 48 24C48 37.2857 37.2857 48 24 48C10.7143 48 0 37.2857 0 24C0 10.7143 10.7143 0 24 0Z"
          fill="#BEEBF6"
        />
        <path
          d="M19.7502 22.653C22.2295 24.9119 26.0209 24.9119 28.5002 22.653M21.5002 17.375V19.125M26.7502 17.375V19.125M34.6252 27.875V14.75C34.6252 13.7835 33.8417 13 32.8752 13H15.3752C14.4087 13 13.6252 13.7835 13.6252 14.75V27.875M34.6252 27.875H13.6252M34.6252 27.875L37.0997 33.2895C37.3402 33.8309 37.2905 34.4571 36.9677 34.9538C36.6448 35.4505 36.0926 35.7501 35.5002 35.75H12.7502C12.1578 35.7501 11.6056 35.4505 11.2828 34.9538C10.9599 34.4571 10.9102 33.8309 11.1507 33.2895L13.6252 27.875M22.3752 32.25H25.8752"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </Icon>
  )
}
